import AddIcon from "assets/icons/AddIcon";
import styles from "./style.module.scss";

export default function AddClassButton({ onClick }: { onClick?: () => void }) {
  return (
    <div className={styles.addIcon} onClick={onClick}>
      <AddIcon />
      Add Classes
    </div>
  );
}
